import React, { useState, useEffect } from "react";
import validator from "validator";
import axios from "axios";
import { useAuth } from "../contexts/auth";
import { postPaymentsURL } from "../utils/api";
import {
    Flex,
    Spacer,
    Button,
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalFooter,
    ModalBody,
    ModalCloseButton,
    FormControl,
    FormLabel,
    FormErrorMessage,
    FormHelperText,
    Input,
    Text,
    RadioGroup,
    Radio,
    HStack,
    Box,
    InputRightElement,
    useColorModeValue,
  } from "@chakra-ui/react";

function CreatePayment({
    isOpen,
    onClose,
    successCallback,
    orderData,
}) {
    const textColor = useColorModeValue("gray.700", "white");   

    if (orderData == null) {
        return (<></>);
    }

    const [ type, setType ] = useState('Cash');
    const [ amount, setAmount ] = useState('0');
    const [ bank, setBank ] = useState(null);
    const [ referenceNumber, setReferenceNumber ] = useState(null);
    const [ accountNumber, setAccountNumber ] = useState(null);
    const [ accountName, setAccountName ] = useState(null);
    const [ chequeNumber, setChequeNumber ] = useState(null);

    const [ invAmount, setInvAmount ] = useState(null);
    const [ invBank, setInvBank ] = useState(null);
    const [ invReferenceNumber, setInvReferenceNumber ] = useState(null);
    const [ invAccountNumber, setInvAccountNumber ] = useState(null);
    const [ invAccountName, setInvAccountName ] = useState(null);
    const [ invChequeNumber, setInvChequeNumber ] = useState(null);

    const { auth } = useAuth();
    const [ errors, setErrors ] = useState([]);
    const [ submitting, setSubmitting ] = useState(false);

    const postPayments = (e) => {
        e.preventDefault();

        let id;
        if (orderData) {
            id = orderData.id;
        }

        setSubmitting(true);
        // console.log(email, password);
        axios.post(postPaymentsURL(id), {
            type,
            bank: type == 'Online'
                ? bank : undefined,
            referenceNumber: type == 'Online'
                ? referenceNumber: undefined,
            accountNumber: type == 'Cheque'
                ? accountNumber: undefined,
            accountName: type == 'Cheque'
                ? accountName: undefined,
            chequeNumber: type == 'Cheque'
                ? chequeNumber: undefined,
            amount,
        },{
            headers: {
                Authorization: `Bearer ${auth.authToken}`
            }
        }).then(result => {
            if (result.status === 200) {
                // const roles = result.data.data.user.roles;
                const user = result.data.data;
                // console.log(user);
                if (successCallback) {
                    successCallback();
                }
                setType('Cash');
                setBank(null);
                setReferenceNumber(null);
                setAccountName(null);
                setAccountNumber(null);
                setChequeNumber(null);
                setAmount('0');
                
                onClose();
            } else {
                setErrors(result.data.errors);
            }
        }).catch(e => {
            if (e.response === undefined) {
                setErrors(['Could not connect to server!'])
            } else {
                setErrors(e.response.data.errors)
            }
        }).finally(e => {
            setSubmitting(false);
        });
    }

    useEffect(() => {

        if (!validator.isEmpty(amount)) {
            setInvAmount(!validator.isNumeric(amount));
        }
        

    }, [amount]);

    return (
        <Modal isOpen={isOpen} onClose={onClose} size="lg">
            <ModalOverlay />
            <ModalContent>
            <ModalHeader>Add Payment to Order</ModalHeader>
            <ModalCloseButton />
            <ModalBody>
                <form onSubmit={postPayments}>
                    <FormControl >
                        <Flex direction="column">
                            <Flex align="center">
                                <Text
                                fontSize="md"
                                color={textColor}
                                fontWeight="bold"
                                me="10px"
                                >
                                Client:{" "}
                                </Text>
                                <Text fontSize="md" color="gray.500" fontWeight="400">
                                { orderData.customer.companyName 
                                    ? orderData.customer.companyName
                                    : `${orderData.customer.firstName} ${orderData.customer.lastName}`
                                }
                                </Text>
                            </Flex>
                            <Flex align="center">
                                <Text
                                fontSize="md"
                                color={textColor}
                                fontWeight="bold"
                                me="10px"
                                >
                                Mobile:{" "}
                                </Text>
                                <Text fontSize="md" color="gray.500" fontWeight="400">
                                { orderData.customer.companyNumber 
                                    ? orderData.customer.companyNumber
                                    : orderData.customer.mobile
                                }
                                </Text>
                            </Flex>
                            <Flex align="center">
                                <Text
                                fontSize="md"
                                color={textColor}
                                fontWeight="bold"
                                me="10px"
                                >
                                Vehicle:{" "}
                                </Text>
                                <Text fontSize="md" color="gray.500" fontWeight="400">
                                { orderData.carMake } { orderData.carType } { orderData.carYear } 
                                { orderData.carPlate } { orderData.carOdometer }
                                </Text>
                            </Flex>

                            <Flex align="center">
                                <Text
                                fontSize="md"
                                color={textColor}
                                fontWeight="bold"
                                me="10px"
                                >
                                Paid / Total:{" "}
                                </Text>
                                <Text fontSize="md" color="gray.500" fontWeight="400">
                                { Number(orderData.paymentsTotal).toLocaleString()}/{ Number(orderData.total).toLocaleString() }
                                </Text>
                            </Flex>

                        </Flex>


                        {/* Payment Type */}
                        <RadioGroup 
                            defaultValue="Cash" mb="12px" 
                            onChange={setType}
                            mt="18px"
                            // value={type}
                        >
                            <HStack spacing="24px">
                                <Radio value="Cash">Cash</Radio>
                                <Radio value="Online">Online</Radio>
                                <Radio value="AccountsReceivable">Accounts Receivable</Radio>
                                <Radio value="Cheque">Cheque</Radio>
                            </HStack>
                        </RadioGroup>


                        <FormLabel ms="4px" fontSize="sm" fontWeight="normal">
                            Amount
                        </FormLabel>
                        <Input
                            borderRadius="15px"
                            mb="12px"
                            fontSize="sm"
                            type="number"
                            placeholder="10000"
                            size="md" 
                            min={1}
                            max={parseFloat(orderData.total) - parseFloat(orderData.paymentsTotal)}
                            isInvalid={invAmount === true}
                            isRequired={true}
                            value={amount} 
                            onChange={e => setAmount(e.target.value)}
                        />
                        
                        { type == 'Online'
                            ? <Box pr="12px">
                                <FormLabel ms="4px" fontSize="sm" fontWeight="normal">
                                    Bank / E-Wallet
                                </FormLabel>
                                <Input
                                    borderRadius="15px"
                                    mb="12px"
                                    fontSize="sm"
                                    type="text"
                                    placeholder="Bank / E-Wallet Name"
                                    size="md" 
                                    isInvalid={invBank === true}
                                    isRequired={true}
                                    value={bank} 
                                    onChange={e => setBank(e.target.value)}
                                />
                            </Box>
                            : null 
                        }
                        

                        { type == 'Online'
                            ? <Box pr="12px">
                                <FormLabel ms="4px" fontSize="sm" fontWeight="normal">
                                    Reference / Transaction Number
                                </FormLabel>
                                <Input
                                    borderRadius="15px"
                                    mb="12px"
                                    fontSize="sm"
                                    type="text"
                                    placeholder="Reference / Transaction Number"
                                    size="md" 
                                    isInvalid={invReferenceNumber === true}
                                    isRequired={true}
                                    value={referenceNumber} 
                                    onChange={e => setReferenceNumber(e.target.value)}
                                />
                            </Box>
                            : null 
                        }

                        { type == 'Cheque'
                            ? <Box pr="12px">
                                <FormLabel ms="4px" fontSize="sm" fontWeight="normal">
                                    Account Number
                                </FormLabel>
                                <Input
                                    borderRadius="15px"
                                    mb="12px"
                                    fontSize="sm"
                                    type="text"
                                    placeholder="Account Number"
                                    size="md" 
                                    isInvalid={invAccountNumber === true}
                                    isRequired={true}
                                    value={accountNumber} 
                                    onChange={e => setAccountNumber(e.target.value)}
                                />
                            </Box>
                            : null 
                        }

                        { type == 'Cheque'
                            ? <Box pr="12px">
                                <FormLabel ms="4px" fontSize="sm" fontWeight="normal">
                                    Account Name
                                </FormLabel>
                                <Input
                                    borderRadius="15px"
                                    mb="12px"
                                    fontSize="sm"
                                    type="text"
                                    placeholder="Account Name"
                                    size="md" 
                                    isInvalid={invAccountName === true}
                                    isRequired={true}
                                    value={accountName} 
                                    onChange={e => setAccountName(e.target.value)}
                                />
                            </Box>
                            : null 
                        }

                        { type == 'Cheque'
                            ? <Box pr="12px">
                                <FormLabel ms="4px" fontSize="sm" fontWeight="normal">
                                    Cheque Number
                                </FormLabel>
                                <Input
                                    borderRadius="15px"
                                    mb="12px"
                                    fontSize="sm"
                                    type="text"
                                    placeholder="Cheque Number"
                                    size="md" 
                                    isInvalid={invChequeNumber === true}
                                    isRequired={true}
                                    value={chequeNumber} 
                                    onChange={e => setChequeNumber(e.target.value)}
                                />
                            </Box>
                            : null 
                        }
                        
                        
                        
                        <Flex w="100%" flexDir="column">
                            { errors.length > 0 && <Text color="red">{errors[0]}</Text> }
                        </Flex>
                        <Button
                            fontSize="10px"
                            type="submit"
                            bg="teal.300"
                            w="100%"
                            h="45"
                            mb="20px"
                            color="white"
                            mt="0px"
                            _hover={{
                            bg: "teal.200",
                            }}
                            _active={{
                            bg: "teal.400",
                            }}
                            isDisabled={submitting}
                        >
                            SUBMIT
                        </Button>
                    </FormControl>
                </form>
            </ModalBody>
            </ModalContent>
        </Modal>
    );

}



export default CreatePayment;
